export const SET_STATS = "SET_STATS";

export default {
  SET_STATS
};
